var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwiperRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 23.5,
    stroke: "#49CE87"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3934 32.6069C19.6455 32.8586 19.9872 33 20.3435 33C20.6997 33 21.0414 32.8586 21.2936 32.6069L28.8918 25.0164C29.1849 24.7233 29.3161 24.3273 29.2801 23.9442C29.2801 23.5971 29.1502 23.2512 28.8867 22.9877L21.2923 15.3933C21.1676 15.2686 21.0196 15.1697 20.8567 15.1022C20.6938 15.0347 20.5192 15 20.3428 15C20.1665 15 19.9919 15.0347 19.829 15.1022C19.6661 15.1697 19.5181 15.2686 19.3934 15.3933C19.2687 15.518 19.1698 15.666 19.1023 15.8289C19.0348 15.9918 19.0001 16.1664 19.0001 16.3427C19.0001 16.5191 19.0348 16.6937 19.1023 16.8566C19.1698 17.0195 19.2687 17.1675 19.3934 17.2922L26.1045 24.0033L19.3934 30.7093C19.2687 30.8338 19.1697 30.9817 19.1022 31.1446C19.0347 31.3074 19 31.4819 19 31.6581C19 31.8344 19.0347 32.0089 19.1022 32.1717C19.1697 32.3345 19.2687 32.4824 19.3934 32.6069Z",
    fill: "#49CE87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwiperRight);
export default __webpack_public_path__ + "static/media/swiper_right.95741a1b2bac6a0c2f4b7561a8283afb.svg";
export { ForwardRef as ReactComponent };